import { useState } from 'react';
import { ErrorContent } from './ErrorContent/ErrorContent';
import { FormContent } from './FormContent/FormContent';
import { SuccessContent } from './SuccessContent/SuccessContent';
import { Modal } from 'components';
import { User } from 'types';

type Props = {
  user: User;
  onClose(): void;
};

export const EditUserModal = ({ onClose, user }: Props) => {
  const [emailUpdated, setEmailUpdated] = useState(false);
  const [email, setEmail] = useState('');
  const [displayError, setDisplayError] = useState(false);

  return (
    <Modal title="Edit user" onClose={onClose}>
      {displayError ? (
        <ErrorContent onConfirm={onClose} />
      ) : !emailUpdated ? (
        <FormContent
          onClose={onClose}
          setEmailUpdated={setEmailUpdated}
          user={user}
          setEmail={setEmail}
          setDisplayError={setDisplayError}
        />
      ) : (
        <SuccessContent onConfirm={onClose} email={email} />
      )}
    </Modal>
  );
};
